module.exports = __webpack_public_path__ + "static/media/logo.8e1c406f.png";